/* eslint-disable consistent-return */
import isServer from 'src/common/utils/isServer';

// Method found here:
// https://jonathanmh.com/how-to-detect-ad-blockers-adblock-ublock-etc/
// Tested with uBlock and AdBlock...
//
export default function isAdBlockEnabled(callback) {
  if (isServer()) {
    return callback(false);
  }

  const url = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

  const params = {
    method: 'HEAD',
    mode: 'no-cors',
  };

  // TODO: fix ad block reporting for IE11
  // Caution: removing window object reference will throw error on browsers without Request support
  if (!window.Request) {
    return;
  }

  const testAdRequest = new Request(url, params);

  fetch(testAdRequest)
    .then(() => callback(false))
    .catch(() => callback(true));
}
